import { EnergySavingsChartTabParams } from '../models/chart/EnergySavingsParams';

export const DEFAULT_ENERGY_SAVINGS_CHART_TAB_PARAMS: EnergySavingsChartTabParams = {
    system: false,
    showOperationProfile: true,
    energySaving: true
};
